<script setup>
import { ref, watch, onMounted, nextTick } from 'vue';

const props = defineProps({
  type: {
    type: String,
  },
  timeout: {
    type: Number,
  }
});

const emit = defineEmits(['cancel', 'countdown', 'close']);

const modalBegin = ref(null);
const modalEnd = ref(null);
const setModalFocus = (ref) => ref.focus();
const countdown = ref(null);
const countingDown = () => {
  countdown.value--;
  if (countdown.value <= 0) {
    emit('countdown');
  } else {
    setTimeout(countingDown, 1000);
  }
}
watch(() => props.timeout, (newValue) => {
  if (newValue) {
    countdown.value = newValue;
    setTimeout(countingDown, 1000);
  }
}, { immediate: true });
onMounted(() => {
  nextTick(() => {
    setModalFocus(modalBegin.value);
  });
});
</script>

<template>
  <div
    class="fixed top-0 left-0 bottom-0 right-0 flex justify-around items-center z-50 bg-modal-background"
    aria-hidden="false"
    aria-modal="true"
    role="dialog"
    @click="emit('cancel')"
    @keydown.esc.prevent="emit('close')"
  >
    <div
      class="w-[578px] border-t-4 bg-white rounded-lg"
      :class="{ 'border-primary-500': type === 'success', 'border-red': type === 'error' }"
    >
      <span ref="modalBegin" tabindex="0" @keydown.tab.shift.prevent=""></span>
      <slot :countdown="countdown" ></slot>
      <span ref="modalEnd" tabindex="0" @focus="setModalFocus(modalBegin)" @keydown.tab.prevent=""></span>
    </div>
  </div>
</template>
